/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/inventory/location
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCheckoutKey,
  ShopifyCheckoutToLocationKey,
  ShopifyFulfillmentKey,
  ShopifyFulfillmentOrderDestinationKey,
  ShopifyFulfillmentOrderDestinationToLocationKey,
  ShopifyFulfillmentOrderKey,
  ShopifyFulfillmentOrderToLocationKey,
  ShopifyFulfillmentServiceKey,
  ShopifyFulfillmentServiceToLocationKey,
  ShopifyFulfillmentToLocationKey,
  ShopifyInventoryItemKey,
  ShopifyInventoryItemToLocationsKey,
  ShopifyInventoryLevelKey,
  ShopifyInventoryLevelToInventoryItemKey,
  ShopifyInventoryLevelToLocationKey,
  ShopifyInventoryQuantityKey,
  ShopifyInventoryQuantityToLocationKey,
  ShopifyLocationKey,
  ShopifyLocationToCheckoutsKey,
  ShopifyLocationToFulfillmentOrderDestinationsKey,
  ShopifyLocationToFulfillmentOrdersKey,
  ShopifyLocationToFulfillmentServicesKey,
  ShopifyLocationToFulfillmentsKey,
  ShopifyLocationToInventoryItemsKey,
  ShopifyLocationToInventoryQuantitiesKey,
  ShopifyLocationToOrderLineItemsKey,
  ShopifyLocationToOrdersKey,
  ShopifyLocationToOrderTransactionsKey,
  ShopifyLocationToRefundLineItemsKey,
  ShopifyLocationToRetailOrdersKey,
  ShopifyLocationToReverseFulfillmentOrderDispositionsKey,
  ShopifyLocationToShopKey,
  ShopifyOrderKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToOriginLocationKey,
  ShopifyOrderToLocationKey,
  ShopifyOrderToRetailLocationKey,
  ShopifyOrderTransactionKey,
  ShopifyOrderTransactionToLocationKey,
  ShopifyRefundLineItemKey,
  ShopifyRefundLineItemToLocationKey,
  ShopifyReverseFulfillmentOrderDispositionKey,
  ShopifyReverseFulfillmentOrderDispositionToLocationKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyLocationKey,
  defaultFilterableApiIdentifiers: ["active"],
  "2022-01": {
    name: "Shopify Location",
    graphQLTypename: "Location",
    fields: [
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "active" } },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address2" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country_code" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToLocationKey,
        },
      },
      {
        name: "Fulfillment Services",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentServicesKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentServiceKey,
          inverseFieldKey: ShopifyFulfillmentServiceToLocationKey,
        },
      },
      {
        name: "Inventory Items",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyLocationToInventoryItemsKey,
        configuration: {
          joinModelKey: ShopifyInventoryLevelKey,
          relatedModelKey: ShopifyInventoryItemKey,
          inverseJoinModelFieldKey: ShopifyInventoryLevelToLocationKey,
          inverseRelatedModelFieldKey: ShopifyInventoryLevelToInventoryItemKey,
          inverseFieldKey: ShopifyInventoryItemToLocationsKey,
        },
      },
      {
        name: "Legacy",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "legacy" } },
      },
      {
        name: "Localized Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_country_name" } },
      },
      {
        name: "Localized Province Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_province_name" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrdersKey,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToLocationKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOriginLocationKey,
        },
      },
      {
        name: "Order Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrderTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToLocationKey,
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "phone" } },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province_code" } },
      },
      {
        name: "Refunded Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToRefundLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyRefundLineItemKey,
          inverseFieldKey: ShopifyRefundLineItemToLocationKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToLocationKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyLocationToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "rest_list",
      resource: "location",
    },
  },
  "2022-10": {
    hasMetafields: true,
  },
  "2023-07": {
    fields: [
      {
        name: "Fulfillment Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentOrdersKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderKey,
          inverseFieldKey: ShopifyFulfillmentOrderToLocationKey,
        },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "Retail Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToRetailOrdersKey,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToRetailLocationKey,
        },
      },
      {
        name: "Reverse Fulfillment Order Dispositions",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToReverseFulfillmentOrderDispositionsKey,
        configuration: {
          relatedModelKey: ShopifyReverseFulfillmentOrderDispositionKey,
          inverseFieldKey: ShopifyReverseFulfillmentOrderDispositionToLocationKey,
        },
      },
    ],
  },
  "2024-10": {
    fields: [
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "active", graphQLFieldKey: "isActive" } },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "address1", graphQLFieldKey: "address1", skipGraphQLSelection: true },
        },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "address2", graphQLFieldKey: "address2", skipGraphQLSelection: true },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "city", graphQLFieldKey: "city", skipGraphQLSelection: true },
        },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "country", graphQLFieldKey: "country", skipGraphQLSelection: true },
        },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "country_code", graphQLFieldKey: "countryCode", skipGraphQLSelection: true },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Fulfillments",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
          inverseFieldKey: ShopifyFulfillmentToLocationKey,
        },
      },
      {
        name: "Fulfillment Services",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentServicesKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentServiceKey,
          inverseFieldKey: ShopifyFulfillmentServiceToLocationKey,
        },
      },
      {
        name: "Inventory Items",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyLocationToInventoryItemsKey,
        configuration: {
          joinModelKey: ShopifyInventoryLevelKey,
          relatedModelKey: ShopifyInventoryItemKey,
          inverseJoinModelFieldKey: ShopifyInventoryLevelToLocationKey,
          inverseRelatedModelFieldKey: ShopifyInventoryLevelToInventoryItemKey,
          inverseFieldKey: ShopifyInventoryItemToLocationsKey,
        },
      },
      {
        name: "Legacy",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "legacy", graphQLFieldKey: "isFulfillmentService" } },
      },
      {
        name: "Localized Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_country_name", skipGraphQLSelection: true } },
      },
      {
        name: "Localized Province Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_province_name", skipGraphQLSelection: true } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name", graphQLFieldKey: "name" } },
      },
      {
        name: "Orders",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrdersKey,
        configuration: {
          relatedModelKey: ShopifyOrderKey,
          inverseFieldKey: ShopifyOrderToLocationKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOriginLocationKey,
        },
      },
      {
        name: "Order Transactions",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrderTransactionsKey,
        configuration: {
          relatedModelKey: ShopifyOrderTransactionKey,
          inverseFieldKey: ShopifyOrderTransactionToLocationKey,
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "phone", graphQLFieldKey: "phone", skipGraphQLSelection: true },
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "province", graphQLFieldKey: "province", skipGraphQLSelection: true },
        },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "province_code", graphQLFieldKey: "provinceCode", skipGraphQLSelection: true },
        },
      },
      {
        name: "Refunded Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToRefundLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyRefundLineItemKey,
          inverseFieldKey: ShopifyRefundLineItemToLocationKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip", graphQLFieldKey: "zip", skipGraphQLSelection: true } },
      },
      {
        name: "Checkouts",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToCheckoutsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutKey,
          inverseFieldKey: ShopifyCheckoutToLocationKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyLocationToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "locations",
      additionalSelection: `address {
  address1
  address2
  city
  country
  countryCode
  phone
  province
  provinceCode
  zip
}
`,
      filters: {},
      extraArgs: {
        includeInactive: true,
      },
    },
  },
  "2025-01": {
    fields: [
      {
        name: "Localized Country Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_country_name", skipGraphQLSelection: true } },
        isDeleted: true,
      },
      {
        name: "Localized Province Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "localized_province_name", skipGraphQLSelection: true } },
        isDeleted: true,
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToOriginLocationKey,
        },
        isDeleted: true,
      },
      {
        name: "Inventory Quantities",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToInventoryQuantitiesKey,
        configuration: {
          relatedModelKey: ShopifyInventoryQuantityKey,
          inverseFieldKey: ShopifyInventoryQuantityToLocationKey,
        },
      },
      {
        name: "Fulfillment Order Destinations",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToFulfillmentOrderDestinationsKey,
        configuration: {
          relatedModelKey: ShopifyFulfillmentOrderDestinationKey,
          inverseFieldKey: ShopifyFulfillmentOrderDestinationToLocationKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "zip",
            graphQLFieldKey: "zip",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Phone",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "phone",
            graphQLFieldKey: "phone",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province",
            graphQLFieldKey: "province",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Province Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province_code",
            graphQLFieldKey: "provinceCode",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Legacy",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "legacy",
            graphQLFieldKey: "isFulfillmentService",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Active",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "active",
            graphQLFieldKey: "isActive",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address1",
            graphQLFieldKey: "address1",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Address 2",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address2",
            graphQLFieldKey: "address2",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "city",
            graphQLFieldKey: "city",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country",
            graphQLFieldKey: "country",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Country Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country_code",
            graphQLFieldKey: "countryCode",
            skipGraphQLSelection: true,
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["locations/create", "locations/update", "locations/deactivate", "locations/activate"],
          },
        },
      },
      {
        name: "Activatable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "activatable",
          },
        },
      },
      {
        name: "Address Verified",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "addressVerified",
          },
        },
      },
      {
        name: "Deactivatable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "deactivatable",
          },
        },
      },
      {
        name: "Deactivated At",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "deactivatedAt",
          },
        },
      },
      {
        name: "Deletable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "deletable",
          },
        },
      },
      {
        name: "Fulfills Online Orders",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "fulfillsOnlineOrders",
          },
        },
      },
      {
        name: "Has Active Inventory",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasActiveInventory",
          },
        },
      },
      {
        name: "Has Unfulfilled Orders",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasUnfulfilledOrders",
          },
        },
      },
      {
        name: "Has Unfulfilled Orders",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasUnfulfilledOrders",
          },
        },
      },
      {
        name: "Legacy Resource Id",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "legacyResourceId",
          },
        },
      },
      {
        name: "Local Pickup Settings V2",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "localPickupSettingsV2",
            graphQLSelection: `
              instructions
              pickupTime
            `,
          },
        },
      },
      {
        name: "Ships Inventory",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shipsInventory",
          },
        },
      },
      {
        name: "Suggested Addresses",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "suggestedAddresses",
            graphQLSelection: `
              address1
              address2
              city
              country
              countryCode
              formatted
              province
              provinceCode
              zip
            `,
          },
        },
      },
    ],
  },
  "2026-01": {
    fields: [
      {
        name: "Inventory Quantities",
        fieldType: FieldType.HasMany,
        key: ShopifyLocationToInventoryQuantitiesKey,
        configuration: {
          relatedModelKey: ShopifyInventoryQuantityKey,
          inverseFieldKey: ShopifyInventoryQuantityToLocationKey,
        },
        isDeleted: true,
      },
    ],
  },
};

export const ShopifyLocation = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
